/* Codehouse Cookie Module | ILM */

var cookies = new Array(),
    hasAcknowledged = false,
    acceptedCookieName = 'allowCookies',
    disabledCookieName = 'disableCookies';

$(document).ready(function () {
    getCookieInfo();
    if (!hasAcknowledged) {
        //showBar();
    }

    // Setup More info Click
    $('.more-info-trigger').click(function () {
        $('.more-info').slideToggle('slow');
        return false;
    });

    $(".ckchk-acceptCookies").click(function () {
        // they accept cookies, set the cookie and hide the bar
        writeAcceptCookie();
        hideBar();
        //reloadPage();
        return false;
    });
});

function reloadPage() {
    // this forces a reload of the page to ensure we don't load a cached copy
    window.location.reload(true);
}

function writeAcceptCookie() {
    var currentDate = new Date();
    currentDate.setYear(currentDate.getFullYear() + 1);
    document.cookie = acceptedCookieName + '=yes;path=/;expires=' + currentDate.toUTCString();
}


function showBar() {
    
    // load the bar as and place right under the body tag
    $.ajax({
        url: '/cookiebar.aspx',
        type: "GET",
        async: false,
        cache: false,
        success: function (html) {
            $("body").prepend(html);
        },
        error: function (data) {
            // do nothing
        }
    });
   
}

function hideBar() {
    $('.more-info').slideUp('slow');
    $('.cookie-module').slideUp('slow');
    //if login query, adjust the white mask
    $('.white-mask').animate({
        'top': $('.site-header').position().top + parseInt($('.login-register').css('margin-top')),
        height: $(document).height() - 251
    });
}

function getCookieInfo() {
    if (!document.cookie) {
        return;
    }
    $.each(document.cookie.split(/; */), function () {
        var splitCookie = this.split('=');
        var ck = new Cookie(splitCookie[0], splitCookie[1]);
        if (ck.name == acceptedCookieName) {
            hasAcknowledged = true;
        }
        else if (ck.name == disabledCookieName) {
            hasAcknowledged = true;
        }
        cookies.push(ck);
    });
}

function Cookie(name, value) {
    this.name = name;
    this.value = value;
}